<template>
  <Background :bgColor="bgColor">
    <Container>
      <Image
        v-if="data.asideImage"
        class="mb-20px flex w-full justify-center md:w-1/3"
        :image="data.asideImage.image"
        :imageAlignment="data.asideImage.imageAlignment" />

      <SectionText
        :listStyle="data.stylizedList"
        :body="data.body"
        :highlightText="data.highlightText"
        :title="data.title"
        :headingTag="data.titleHeadingTag"
        :buttons="data.buttons"
        @btn-click="onClick">
      </SectionText>
    </Container>
  </Background>
</template>

<script>
import Background from "../Atoms/Background.vue";
import Container from "../Atoms/Container.vue";
import Image from "../Atoms/Image.vue";
import SectionText from "../Modules/SectionText.vue";

export default {
  components: {
    Background,
    Container,
    Image,
    SectionText,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  emits: ["btn-click"],

  setup(props, { emit }) {
    let bgColor = "white";

    if (props.data.backgroundColor) {
      bgColor = props.data.backgroundColor;
    }
    const onClick = (...args) => {
      // Bubble up all arguments
      emit("btn-click", ...args);
    };

    return {
      bgColor,
      onClick,
    };
  },
};
</script>

<style></style>
